import mixpanel from 'mixpanel-browser';
import ReactGA from 'react-ga';

import app_params from '../../../config/params';

const init = () => {
  mixpanel.init(app_params.ANALYTICS.MIXPANEL.TOKEN);
  ReactGA.initialize(app_params.ANALYTICS.GOOGLE.TRACKING_ID);
};


const trackView = (path) => {
  ReactGA.pageview(path);
  mixpanel.track('page_view');
};


const trackEvent = (category, action, fields = {}, label = undefined, value = undefined) => {
  const googleOptions = { category, action };

  const mixpanelEvent = `${category}_${action}`;
  const mixpanelParams = fields;

  if (typeof (label) !== 'undefined') {
    mixpanelParams.label = label;
    googleOptions.label = label;
  }

  if (typeof (value) !== 'undefined') {
    mixpanelParams.value = value;
    googleOptions.value = value;
  }

  ReactGA.event(googleOptions);

  mixpanel.track(mixpanelEvent, mixpanelParams);
};


const identify = (userEmail) => {
  mixpanel.identify(userEmail);
  // Google analytics terms forbid us from using email in user id field
};


export const analytics = {
  init,
  identify,
  trackView,
  trackEvent,
};



// WEBPACK FOOTER //
// ./scripts/modules/analytics.js